module.exports = __webpack_public_path__ + "img/matrix.9a9ce28e.png";